import { useDispatch, useSelector } from "react-redux"

import { caseActions } from "../../../../../store/case"
import { caseQuickUpdate } from "../../../../../lib/fetchApi"
import { notificationActions } from "../../../../../store/notifications"



import SurgicalTab1 from "../surgicalTab/SurgicalTab1"
import SurgicalTab2 from "../surgicalTab/SurgicalTab2"

import classes from '../SurgicalDrawer.module.css'

export default function SurgicalDrawer1({itemData, apiCase}) {
    const dispatch = useDispatch()

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase) 


    const updateHandler = async (data) => {
        let reqBody = {
            type: data.identifier.type,
            type_id: data.identifier.type_id,
            fields: {
                [data.identifier.field] : data.data.value,
            }
        }

        setTimeout(() => {
            dispatch(caseActions.modifyActiveCase({
                folder: data.identifier.folder,
                item: {
                    itemId: itemData.id,
                    field: data.identifier.field,
                    value: data.data.value,
                },
            }))
        }, 0)

        let update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody, dispatch)

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))
        }     
    }   

    return <div className={`${classes.drawer_container} ${classes.drawer_container_2}`}>
        <SurgicalTab1 classes={classes} updateHandler={updateHandler} itemData={itemData} activeCase={activeCase} apiCase={apiCase}/>

        <SurgicalTab2 classes={classes} updateHandler={updateHandler} itemData={itemData} activeCase={activeCase} apiCase={apiCase}/>
    </div>
}